import { render, staticRenderFns } from "./CostosPorUnidadMaquinaMantenimiento.vue?vue&type=template&id=1320eb06&"
import script from "./CostosPorUnidadMaquinaMantenimiento.vue?vue&type=script&lang=js&"
export * from "./CostosPorUnidadMaquinaMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports